import script from "./centerTopBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./centerTopBackground.vue?vue&type=script&setup=true&lang=js"

import "./centerTopBackground.vue?vue&type=style&index=0&id=77b08e8f&lang=css"

const __exports__ = script;

export default __exports__